<template lang="pug">
main
  PmHeader
  .container
    br
    article.message.is-info
      .message-header
        p Información Tributaria
      .message-body
        .p
          strong Nombre Comercial:
          | {{ ' ' + contribuyente.nombreComercial }}
        .p
          strong Razón Social:
          | {{ ' ' + contribuyente.razonSocial }}
        .p
          strong RUC:
          | {{ ' ' + contribuyente.ruc }}
        .p
          strong Dirección:
          | {{ ' ' + contribuyente.direccionMatriz }}
        .p
          strong Obligado a llevar contabilidad:
          | {{ ' ' + contribuyente.obligadoContabilidad }}
        .p(v-show="contribuyente.contribuyenteEspecial")
          strong Contribuyente Especial:
          | {{ ' ' + contribuyente.contribuyenteEspecial }}
        .p(v-show="contribuyente.contribuyenteRimpe")
          strong Régimen:
          | {{ ' ' + contribuyente.contribuyenteRimpe }}
        .p(v-show="contribuyente.agenteRetencion")
          strong Agente de Retención Resolución Nº:
          | {{ ' ' + contribuyente.agenteRetencion }}
      br
</template>
<script>
import trackService from '@/services/track'
import PmHeader from '../components/layout/Header.vue'

export default {
  components: {
    PmHeader
  },

  data: () => ({
    contribuyente: {},
    isLoading: false,
    showNotification: false
  }),

  mounted() {
    if (localStorage.getItem('token')) {
      this.usuario = JSON.parse(localStorage.getItem('usuario'))
    } else {
      this.$router.push('/')
    }    
  },

  methods: {
    getDatosEmpresa () {
      this.isLoading = true
      trackService.contribuyente()
        .then(res => {
          // console.log(res)
          this.showNotification = res.length === 0
          this.contribuyente = res
          this.isLoading = false
        })
    }
  },
  beforeMount () {
    this.getDatosEmpresa()
  }
}
</script>
<style lang="scss" scoped>
</style>
